var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrandardPlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.1617 6.25586H39.8581C40.5246 6.25586 41.1508 6.57478 41.5429 7.11382L49.5071 18.0647C49.7994 18.4665 49.7671 19.0188 49.4302 19.3839L25.7752 45.0099C25.385 45.4326 24.7261 45.4591 24.3033 45.0689C24.2829 45.0499 24.2633 45.0303 24.2444 45.0099L0.589577 19.3839C0.252565 19.0188 0.220323 18.4665 0.512565 18.0647L8.4768 7.11382C8.86884 6.57478 9.49514 6.25586 10.1617 6.25586Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrandardPlan);
export default __webpack_public_path__ + "static/media/strandard-plan.c2c653074e06fee35d51a4196843c81e.svg";
export { ForwardRef as ReactComponent };